import { MatTableDataSource } from '@angular/material/table';
import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { map, finalize } from 'rxjs/operators';
import { Router, Routes } from '@angular/router';
import { RouteService } from 'src/app/shared/services/route.service';

export interface estudiante {
  cantCursos: number;
  email: string;
  fechaRegistro: any;
  nombre: string;
  id: string;
}

@Component({
  selector: 'lista-estudiantes',
  templateUrl: './lista-estudiantes.component.html',
  styleUrls: ['./lista-estudiantes.component.css']
})

export class ListaEstudiantesComponent implements OnInit {

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private router: Router,
    public routeService: RouteService,
  ) { }

  array: estudiante[];

  ngOnInit(): void {
    this.cargarEstudiantes();
  }

  cargarEstudiantes() {
    this.afs.doc("global/indiceUsuarios").get().subscribe(snap => {
      const usuario = snap.data();
      let arr = []
      Object.keys(usuario).map(function (key) {
        arr.push(usuario[key])
        return arr;
      });
      const length = arr.length
      let arreglo = []
      for (let index = 0; index < length; index++) {
        const estudiante: estudiante = {
          cantCursos: arr[index].cantCursos,
          email: arr[index].email,
          fechaRegistro: arr[index].fechaRegistro,
          nombre: arr[index].nombreCompleto,
          id: arr[index].uid,
        }
        arreglo.push(estudiante)
      }
      this.array = arreglo
      this.array.sort((a,b) => +b.fechaRegistro - +a.fechaRegistro)
      console.log(arreglo)
    })
  }

}


